import { useRef } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { LANGS } from "@/i18n/translations";
import { useLang } from "@/i18n/LanguageContext";

export function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  const pick = (code) => {
    setLang(code);
    if (ref.current) ref.current.open = false;
  };

  return (
    <details ref={ref} className="relative group">
      <summary
        data-testid="lang-switcher-btn"
        className="list-none flex items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur px-3 py-2 text-sm text-zinc-300 hover:text-white hover:border-white/30 transition-colors cursor-pointer select-none [&::-webkit-details-marker]:hidden"
        aria-label="Language"
      >
        <Globe size={15} />
        <span className="uppercase text-xs tracking-wider">{current.code}</span>
        <ChevronDown size={13} className="opacity-70 group-open:rotate-180 transition-transform" />
      </summary>

      <div className="absolute end-0 mt-2 w-44 rounded-xl border border-white/10 bg-[#0a0a0a] p-1.5 shadow-2xl z-[60]">
        {LANGS.map((l) => (
          <button
            key={l.code}
            type="button"
            data-testid={`lang-option-${l.code}`}
            onClick={() => pick(l.code)}
            className={`w-full flex items-center justify-between gap-2 rounded-lg px-3 py-2 text-sm transition-colors ${
              l.code === lang ? "bg-white/10 text-white" : "text-zinc-400 hover:text-white hover:bg-white/5"
            }`}
          >
            <span className="flex items-center gap-2"><span>{l.flag}</span> {l.label}</span>
            {l.code === lang && <Check size={14} />}
          </button>
        ))}
      </div>
    </details>
  );
}
